export enum Fellowship {
    "Cour d'appel d'Agen",
    "Cour d'appel d'Aix",
    "Cour d'appel d'Amiens",
    "Cour d'appel d'Angers",
    "Cour d'appel d'Orléans",
    "Cour d'appel de Basse-Terre",
    "Cour d'appel de Bastia",
    "Cour d'appel de Besançon",
    "Cour d'appel de Bordeaux",
    "Cour d'appel de Bourges",
    "Cour d'appel de Caen",
    "Cour d'appel de Chambéry",
    "Cour d'appel de Colmar",
    "Cour d'appel de Dijon",
    "Cour d'appel de Douai",
    "Cour d'appel de Fort-de-France",
    "Cour d'appel de Grenoble",
    "Cour d'appel de Limoges",
    "Cour d'appel de Lyon",
    "Cour d'appel de Metz",
    "Cour d'appel de Montpellier",
    "Cour d'appel de Nancy",
    "Cour d'appel de Nîmes",
    "Cour d'appel de Paris",
    "Cour d'appel de Pau",
    "Cour d'appel de Poitiers",
    "Cour d'appel de Reims",
    "Cour d'appel de Rennes",
    "Cour d'appel de Riom",
    "Cour d'appel de Rouen",
    "Cour d'appel de Saint-Denis",
    "Cour d'appel de Toulouse",
    "Cour d'appel de Versailles"
}

export enum Membership {
    Advertiser = "advertiser",
    Member = "member"
}

